import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchMyLeaderShip = createAsyncThunk("fetchMyLeaderShip", async () => {
	try {
		const token = localStorage.getItem("auth_token");

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};

		return axiosHttp
			.get(`analytics/summary?myLeaderShip=true`, config)
			.then((data) => {
				return data?.data;
			})
			.catch((err) => {
				return err?.response?.data;
			});
	} catch (error) {
		throw error;
	}
});

const myLeaderShipSlice = createSlice({
	name: "myLeaderShipSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetMyLeaderShipSliceState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMyLeaderShip.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMyLeaderShip.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchMyLeaderShip.rejected, (state, action) => {
			state.isLoading = false;
			state.data = null;
			state.error = action.payload;
		});
	},
});

export const { resetMyLeaderShipSliceState } = myLeaderShipSlice.actions;
export default myLeaderShipSlice.reducer;
